import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import SEO from '../components/SEO';
import './UnitKerjaPage.css'; // Kita akan buat file CSS ini nanti
import NotFoundPage from './NotFoundPage';

const UnitKerjaPage = () => {
  const { unitId } = useParams(); // Mendapatkan 'kesiswaan' atau 'kurikulum' dari URL
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      if (!unitId) return;
      setLoading(true);
      try {
        const docRef = doc(db, 'unitKerja', unitId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const pageData = docSnap.data();
          setContent(pageData);
        } else {
          setError('Halaman tidak ditemukan.');
        }
      } catch (err) {
        setError('Gagal memuat data halaman.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, [unitId]);

  if (loading) {
    return <div className="loading-container">Memuat...</div>;
  }

  if (error) {
    return <NotFoundPage />;
  }

  // Fungsi bantuan untuk membuat kutipan dari HTML
  const createExcerpt = (htmlString, length = 155) => {
    if (!htmlString) return '';
    const text = htmlString.replace(/<[^>]+>/g, ''); // Hapus tag HTML
    if (text.length <= length) return text;
    return text.substring(0, length).trim() + '...';
  };

  return (
    <>
      {content && (
        <SEO 
          title={`${content.title} - SMK Pariwisata Sumbangsih`}
          description={createExcerpt(content.description) || `Informasi mengenai ${content.title} di SMK Pariwisata Sumbangsih.`}
        />
      )}
      <div className="unit-kerja-page">
        <header className="unit-kerja-header" style={{ backgroundImage: `url(${content.imageUrl || 'https://via.placeholder.com/1500x400'})` }}>
          <div className="unit-kerja-header-overlay">
            <h1>{content.title}</h1>
          </div>
        </header>

        <main className="unit-kerja-main-content">
          <div className="unit-kerja-description" dangerouslySetInnerHTML={{ __html: content.description }}>
          </div>

          {content.programs && content.programs.length > 0 && (
            <section className="unit-kerja-programs">
              <h2>Program & Kegiatan</h2>
              <div className="programs-list">
                {content.programs.map((program, index) => (
                  <div key={index} className="program-item">
                    <h3>{program.title}</h3>
                    <p>{program.description}</p>
                  </div>
                ))}
              </div>
            </section>
          )}
        </main>

      </div>
    </>
  );
};

export default UnitKerjaPage;
